import { writable } from 'svelte/store';
import { NotificationSystemApp } from './NotificationSystemApp';

export let NotificationSystem = writable<NotificationSystemApp>(new NotificationSystemApp());
